export function parseDate(s) {
  if (!s) return null;
  const iso = String(s).trim().replace(' ', 'T');
  const d = new Date(iso);
  if (isFinite(d.getTime())) return d;
  const d2 = new Date(s);
  return isFinite(d2.getTime()) ? d2 : null;
}

export function isoDate(d) {
  return d.toISOString().slice(0, 10);
}

export function startOfWeek(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  const day = (x.getDay() + 6) % 7;
  x.setDate(x.getDate() - day);
  return x;
}

export function startOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}

export function bucketKey(d, grain) {
  if (!d) return '—';
  if (grain === 'day') return isoDate(d);
  if (grain === 'week') return isoDate(startOfWeek(d));
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
}

// Parse gviz "Date(yyyy,m,d[,h,m,s])" string → Date (m is 0-indexed)
export function parseGvizDate(v) {
  if (v == null) return null;
  if (v instanceof Date) return v;
  const s = String(v);
  const m = s.match(/^Date\((\d+),(\d+),(\d+)(?:,(\d+),(\d+),(\d+))?\)$/);
  if (m) return new Date(+m[1], +m[2], +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0));
  return parseDate(s);
}
